'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _zh_CN = require('rc-calendar/lib/locale/zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _rcCalendar = require('rc-calendar');

var _rcCalendar2 = _interopRequireDefault(_rcCalendar);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Calendar = function (_React$Component) {
    (0, _inherits3["default"])(Calendar, _React$Component);

    function Calendar() {
        (0, _classCallCheck3["default"])(this, Calendar);
        return (0, _possibleConstructorReturn3["default"])(this, _React$Component.apply(this, arguments));
    }

    Calendar.prototype.render = function render() {
        (0, _warning2["default"])(false, 'DatePicker.Calendar is deprecated, use Calendar instead.');
        return _react2["default"].createElement(_rcCalendar2["default"], this.props);
    };

    return Calendar;
}(_react2["default"].Component);

exports["default"] = Calendar;

Calendar.defaultProps = {
    locale: _zh_CN2["default"],
    prefixCls: 'ant-calendar'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/date-picker/Calendar.js
// module id = 553
// module chunks = 0